import script from "./PCPartsDetailsCardMainHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsDetailsCardMainHeader.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsDetailsCardMainHeader.vue?vue&type=style&index=0&id=0e825457&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e825457"]])

export default __exports__